import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@routingModule';

import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { PrimengModule } from '@modules/primeng.module';
import { ConfigurarRelatorioCaixaComponent } from './components/configurar-relatorio-caixa.component';
import { ConfigurarRelatorioCaixaApiService } from './services/configurar-relatorio-caixa-api.service';
import { ConfigurarRelatorioCaixaResolver } from './configurar-relatorio-caixa.resolver';

@NgModule({
  declarations: [
    ConfigurarRelatorioCaixaComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
  ],
  providers: [
    { provide: ConfigurarRelatorioCaixaApiService, useClass: ConfigurarRelatorioCaixaApiService },
    ConfigurarRelatorioCaixaResolver,
  ],
})
export class ConfigurarRelatorioCaixaModule { }
